// import { Component } from 'react';
import styled from "styled-components";
import colors from "../../utils/style/colors";
import { useState } from "react";
import * as XLSX from "xlsx";
import sanitizeExcelRows from "../../utils/functions/sanitizeExcelRow";

const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
`;
const ModalContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh; /* Limite la hauteur */
    overflow-y: auto; /* Permet de défiler verticalement */
    z-index: 1010; /* Au-dessus de la modale de fond */
    background: white;
    padding: 20px;
    border-radius: 8px;

    /*display: flex;
     flex-direction: column;
    justify-content: center;
    align-items: center; */
    border: 5px ${colors.secondary} solid;
    .projetNom {
        font-size: 2.4rem;
        font-weight: bold;
    }
    p {
        font-size: 1.4rem;
    }
    h2 {
        margin: 10px;
    }
    select {
        font-size: 1rem;
        font-weight: bold;
        padding: 5px 10px;
        margin: 5px;
        border-radius: 5px;
    }
    button {
        border: none;
        color: ${colors.secondary};
        padding: 5px;
        background-color: #e0e0e0;
        border-radius: 30px;
        padding: 15px;
        font-weight: bold;
    }
    button:hover {
        cursor: pointer;
        text-decoration: underline;
    }
    .boutonSupp {
        background-color: red;
        padding: 0 1px;
        margin: 0 6px;
        color: #ffffff;
        font-size: 1.2rem;
        border-radius: 2px;
        :hover {
            text-decoration: none;
            cursor: pointer;
        }
    }
`;
const Element = styled.div`
    display: flex;
    flex-direction: column;
    margin: 20px;
`;
const ChoiceButtons = styled.div`
    .btnModal {
        padding: 10px 15px;
        border-radius: 4px;
        border: none;
        margin: 20px;
        color: #fff;
        cursor: pointer;
    }
    .btnModal1 {
        background-color: #007bff;
        margin-top: 0;
    }
    .btnModal2 {
        background-color: rgb(249, 64, 64);
    }
`;

const ModalDevisFacture = ({ type, handleCloseDF, infosProjet }) => {
    // gréer un devis, une facture
    const [TVA, setTVA] = useState(18);
    const [remise, setRemise] = useState(0);
    const [conditions, setConditions] = useState("");
    const [valid, setValid] = useState("");
    const [garanty, setGaranty] = useState("");
    const [delai, setDelai] = useState("");
    const [nomDevis, setNomDevis] = useState("");
    const [selectedCheckBox, setSelectedCheckBox] = useState([]);
    const [data, setData] = useState([]);

    const [checkColumns, setCheckColumns] = useState([]);

    const allLines = data.flat();

    const maxColumns = Math.max(...allLines.map((row) => row.length));

    const handleFile = async (selectedId) => {
        if (!selectedId) return;
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(
                `${apiUrl}/api/documents/downloadFileXLSX`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        docId: selectedId,
                    }),
                }
            );

            if (!response.ok) {
                console.error("Erreur lors du téléchargement du document");
            } else {
                //   récupération des données avec la librairie XLSX
                const arrayBuffer = await response.arrayBuffer();
                const workbook = XLSX.read(arrayBuffer, { type: "array" });
                const cleanData = workbook.SheetNames.map((sheetName) => {
                    const sheet = workbook.Sheets[sheetName];
                    const jsonData = XLSX.utils.sheet_to_json(sheet, {
                        header: 1,
                    }); // array of arrays
                    return sanitizeExcelRows(jsonData); //  fonction de nettoyage et de mise en forme
                });
                const updatedData = [...data, ...cleanData];
                setData(updatedData);

                const newCheckColumns = updatedData.map((sheet) => {
                    const maxColumns = Math.max(
                        ...sheet.map((row) => row.length || 0)
                    );
                    return Array(maxColumns).fill(true);
                });

                setCheckColumns(newCheckColumns);
            }
        } catch (error) {
            console.error("Erreur lors du téléchargement", error);
        }
    };

    const handleCellChange = (sheetIndex, rowIndex, colIndex, value) => {
        const newData = [...data];
        if (!newData[sheetIndex][rowIndex]) newData[sheetIndex][rowIndex] = [];
        newData[sheetIndex][rowIndex][colIndex] = value;
        setData(newData);
    };

    const closeElement = (event) => {
        const indexToRemove = Number(event.currentTarget.dataset.index);
        const newData = data.filter((_, index) => index !== indexToRemove);
        setData(newData);
        const newCheckColumns = checkColumns.filter(
            (_, index) => index !== indexToRemove
        );
        setCheckColumns(newCheckColumns);
    };

    const handleMakeDF = async (type) => {
        const arrayNamePU = ["PU", "Prix Unitaire", "PRIX UNITAIRE"];
        const arrayNameQuantity = ["Qté", "QTE", "Qte", "QTY"];
        // on vérifie ici que toutes les sheets ont le même maximum de colonnes
        const formData = new FormData();
        if (type === "Devis") {
            if (nomDevis === "" || nomDevis === null) {
                alert(
                    "Important: Le nom du devis est obligatoire pour la création du devis"
                );
                return;
            }
          
            // on filtre d'abord les colonnes sélectionnées dans les différentes sheet
            const getFilteredDataOnColumn = () => {
                return data.map((sheet, sheetIndex) =>
                    sheet.map(
                        (row) =>
                            Array.from(row).filter(
                                (_, colIndex) =>
                                    checkColumns[sheetIndex][colIndex]
                            ) //Array.from force row à être un array complet (empty est remplacé par undefined) sinon filter "saute" les espaces vides et casse l'intégrité du tableau!!!
                    )
                );
            };

            const filteredDataColumn = getFilteredDataOnColumn();
           

            //on vérifie le nombre de volonnes cochées....
            const activeColCounts = checkColumns.map(
                (sheet) => sheet.filter(Boolean).length
            );

            const allEqual = activeColCounts.every(
                (count) => count === activeColCounts[0]
            );

            if (allEqual) {
                let selectedData = [];
                selectedData = selectedCheckBox.map(
                    ([x, y]) => filteredDataColumn[x][y]
                );

                selectedData = selectedData.map((arrayDatas) => {
                    for (let index = 0; index < activeColCounts[0]; index++) {
                        arrayDatas[index] =
                            arrayDatas[index] === null ||
                            arrayDatas[index] === ""
                                ? null
                                : arrayDatas[index];
                    }
                    return arrayDatas;
                });

                // on vérifie que la première ligne contienne bien "PU" ou son équivalent et "Qté" ou son équivalent....
                const firstLineContainPU = selectedData[0].some((element) => {
                    return arrayNamePU.includes(element);
                });
                const firstLineContainQuantity = selectedData[0].some(
                    (element) => {
                        return arrayNameQuantity.includes(element);
                    }
                );

                if (!(firstLineContainPU && firstLineContainQuantity)) {
                    alert(
                        "Les \"mots-clés\" PU et Quantité (ou leur équivalent) n'apparaissent pas dans la 1ère ligne sélectionnée!"
                    );
                    return;
                }

                formData.append("projetId", infosProjet.id);
                formData.append("type", type);
                formData.append("tva", TVA);
                formData.append("remise", remise);
                formData.append("conditions", conditions);
                formData.append("validite", valid);
                formData.append("garanty", garanty);
                formData.append("delai", delai);
                formData.append("nomPDF", nomDevis);
                formData.append("data", JSON.stringify(selectedData));
            } else  {
                alert(
                    'Le nombre de colonnes sélectionnées dans les différents tableaux n\'est pas le même!'
                );
                return;
            } 
        } else if (type === "Facture") {
            formData.append("projetId", infosProjet.id);
            formData.append("type", type);
        } else return;

        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(`${apiUrl}/api/documents/createPDF`, {
                method: "POST",
                credentials: "include",
                body: formData, // Envoi du FormData
            });

            const data = await response.json();

            if (!response.ok) {
                // console.log(data.error);
            } else {
                console.log(data.status);

                handleCloseDF();
            }
        } catch (error) {
            console.error("Erreur:", error);
        }
    };

    const changeSelectedCheckBox = (id) => {
        const exists = selectedCheckBox.some(
            (item) => item[0] === id[0] && item[1] === id[1]
        );

        let updated;

        if (exists) {
            updated = selectedCheckBox.filter(
                (item) => !(item[0] === id[0] && item[1] === id[1])
            );
        } else {
            updated = [...selectedCheckBox, id];
        }

        // Tri : d'abord sur x (item[0]), puis sur y (item[1])
        updated.sort((a, b) => {
            if (a[0] !== b[0]) return a[0] - b[0];
            return a[1] - b[1];
        });

        setSelectedCheckBox(updated);
    };

    const handleToggleColumn = (sheetIndex, colIndex) => {
        setCheckColumns((prev) =>
            prev.map((sheet, indexSheet) =>
                indexSheet === sheetIndex
                    ? sheet.map((val, index) =>
                          index === colIndex ? !val : val
                      )
                    : sheet
            )
        );
    };

    return (
        <Modal>
            <ModalContainer>
                {type === "Devis" && <h2>Editer un devis</h2>}
                {type === "Facture" && <h2>Editer la/les facture(s)</h2>}
                {type === "Devis" && (
                    <select
                        onChange={(event) => {
                            const selectedId = event.target.value;
                            if (selectedId) {
                                handleFile(selectedId);
                            }
                        }}
                        value="Charger un BoQ"
                    >
                        <option value="">Charger un BoQ</option>

                        {infosProjet.documents
                            .filter((doc) => doc.nom.endsWith(".xlsx"))
                            .map((doc) => (
                                <option key={doc.id} value={doc.id}>
                                    {doc.nom}
                                </option>
                            ))}
                    </select>
                )}
                {data.length > 0 &&
                    data.map((sheetData, sheetIndex) => (
                        <Element>
                            <div>
                                Supprimer cet élément
                                <button
                                    data-index={sheetIndex}
                                    onClick={(event) => closeElement(event)}
                                    aria-label="Fermer"
                                    className="boutonSupp"
                                >
                                    ×
                                </button>
                            </div>
                            <table
                                key={sheetIndex}
                                border="1"
                                style={{
                                    marginTop: "20px",
                                    borderCollapse: "collapse",
                                }}
                            >
                                {/* checkbox de colonnes */}
                                <thead>
                                    <tr>
                                        <td>Sélectionner</td>
                                        {Array.from({ length: maxColumns }).map(
                                            (_, colIndex) => (
                                                <td
                                                    key={colIndex}
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id={[
                                                            sheetIndex,
                                                            colIndex,
                                                        ]}
                                                        checked={
                                                            checkColumns[
                                                                sheetIndex
                                                            ]?.[colIndex] ??
                                                            false
                                                        }
                                                        onChange={() =>
                                                            handleToggleColumn(
                                                                sheetIndex,
                                                                colIndex
                                                            )
                                                        } // ton handler
                                                    />
                                                </td>
                                            )
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {sheetData.map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <td
                                                style={{
                                                    width: "50px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    name={rowIndex}
                                                    id={[sheetIndex, rowIndex]}
                                                    onChange={() =>
                                                        changeSelectedCheckBox([
                                                            sheetIndex,
                                                            rowIndex,
                                                        ])
                                                    }
                                                />
                                            </td>
                                            {Array.from({
                                                length: maxColumns,
                                            }).map((_, colIndex) => (
                                                <td key={colIndex}>
                                                    <input
                                                        value={
                                                            row[colIndex] ?? ""
                                                        }
                                                        onChange={(e) =>
                                                            handleCellChange(
                                                                sheetIndex,
                                                                rowIndex,
                                                                colIndex,
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            width: "200px",
                                                            height: "auto",
                                                            border: "none",
                                                            padding: "4px",
                                                        }}
                                                    />
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Element>
                    ))}

                {/* Si il y a des données chargées autoriser la complétion des données du devis TVA remise Coditions etc.... */}
                {data.length > 0 && (
                    <>
                        {" "}
                        <label htmlFor="txTVA">
                            Nom du devis (obligatoire)
                        </label>
                        <br />
                        <input
                            type="text"
                            name="nomDevis"
                            id="nomDevis"
                            onChange={(e) => setNomDevis(e.currentTarget.value)}
                        />
                        <br />
                        <label htmlFor="txTVA">
                            Taux de TVA (18% par défaut)
                        </label>
                        <br />
                        <input
                            type="number"
                            name="txTVA"
                            id="txTVA"
                            onChange={(e) => setTVA(e.currentTarget.value)}
                        />
                        <br />
                        <label htmlFor="remise">
                            % de remise (0% par défaut)
                        </label>
                        <br />
                        <input
                            type="number"
                            name="remise"
                            id="remise"
                            onChange={(e) => setRemise(e.currentTarget.value)}
                        />
                        <br />
                        <label htmlFor="conditions">Conditions</label>
                        <br />
                        <textarea
                            type="text"
                            id="conditions"
                            name="conditions"
                            cols="40"
                            rows="5"
                            onChange={(e) =>
                                setConditions(e.currentTarget.value)
                            }
                        />{" "}
                        <br />
                        <label htmlFor="valid">Validité</label>
                        <br />
                        <input
                            type="text"
                            name="valid"
                            id="valid"
                            onChange={(e) => setValid(e.currentTarget.value)}
                        />
                        <br />
                        <label htmlFor="garanty">Garantie</label>
                        <br />
                        <input
                            type="text"
                            name="garanty"
                            id="garanty"
                            onChange={(e) => setGaranty(e.currentTarget.value)}
                        />
                        <br />
                        <label htmlFor="delai">Délai de livraison</label>
                        <br />
                        <input
                            type="text"
                            name="delai"
                            id="delai"
                            onChange={(e) => setDelai(e.currentTarget.value)}
                        />
                    </>
                )}

                <ChoiceButtons>
                    {data.length > 0 && (
                        <button
                            onClick={() => handleMakeDF(type)}
                            className="btnModal btnModal1"
                        >
                            Créér le document
                        </button>
                    )}
                    <button
                        onClick={() => handleCloseDF()}
                        className="btnModal btnModal2"
                    >
                        Fermer
                    </button>
                </ChoiceButtons>
            </ModalContainer>
        </Modal>
    );
};

export default ModalDevisFacture;
